import { render } from "./BFormTimepicker.vue?vue&type=template&id=b6acb744"
import script from "./BFormTimepicker.vue?vue&type=script&lang=js"
export * from "./BFormTimepicker.vue?vue&type=script&lang=js"

import "./BFormTimepicker.vue?vue&type=style&index=0&id=b6acb744&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__